<template>
  <v-main>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-overlay :value="newCustomerStatusOverlay"></v-overlay>
    <v-card
    :ripple="false"
    :img="ImgCover"
    height="240px"
    width="100%"
    >
    </v-card>
    <v-card class="pa-6 px-3 pb-10 mt-n10"
          :color="DarkModeBackground"
          :style="'background-color:'+ DarkModeBackground +';min-height: 100vh;border-radius: 45px 45px 0px 0px;'"
          >
        <v-row>
          <v-col class="text-center">
            <v-avatar class="mt-n16 pa-1" style="" :color="DarkModeBackground" size="150">
            <img
              :src="LoGo"
            >
          </v-avatar>
          </v-col>
         </v-row>
      <v-sheet
        class="mx-auto mt-5 pa-0 pt-5 pb-5"
        min-height="60vh"
        rounded
        :style="'background-color:' + '#FFFFFF' +';border-radius: 15px 15px 15px 15px;'"
      >
      <div style="display:flex;justify-content: center;" class="ma-3">
            <v-chip
              class="mr-1 font-weight-black"
              :style="'background-color:' + (languageSelect === 0 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:20px'"
              dark
              @click="languageSelect = 0"
              >
              <v-avatar left>
                <v-img src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e"></v-img>
              </v-avatar>
                TH
            </v-chip>
            <v-chip
              class="ml-1 font-weight-black"
              :style="'background-color:' + (languageSelect === 1 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:20px'"
              dark
              @click="languageSelect = 1">
              <v-avatar left>
                <v-img src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b"></v-img>
              </v-avatar>
                EN
            </v-chip>
          </div>
       <h2
          class="text-center mt-1 font-weight-bold"
          :style="'color:' + '#000000' + ';'"
          v-if="shop.length > 0"
        >
        {{ languageSelect === 0 ? "ตรวจสอบคิวนัดหมาย" : "Check queue" }}
        </h2>
        <h4
          class="text-center mt-1 font-weight-bold"
          :style="'color:' + '#000000' + ';'"
          v-if="shop.length > 0 && shop[0].showShopName === 'True'"
        >
          {{ shop[0].shopName }}
        </h4>
        <v-row align="center" class="pa-4 pl-7">
          <v-col cols="12">
            <v-select
              v-if="branch.length > 1"
              v-model="formSelect.masBranchID"
              :label="languageSelect === 0 ? 'สาขา *' : 'Branch *'"
              dense
              outlined
              :item-text="languageSelect === 0 ? 'text' : 'textEn'"
              :items="branch"
              attach
              :menu-props="{ bottom: true, offsetY: true }"
              @change="selectBranch(), formSelect.group_Flow_Id = ''"
            ></v-select>
            <v-select
              v-if="formSelect.masBranchID !== '' && formSelect.masBranchID !== null"
              v-model="formSelect.group_Flow_Id"
              :label="languageSelect === 0 ? 'ประเภทบริการ *' : 'Service *'"
              dense
              outlined
              :item-text="languageSelect === 0 ? 'text' : 'textEn'"
              :items="groupFlow"
              attach
              :menu-props="{ bottom: true, offsetY: true }"
              @change="selectGroupFlow(), formSelect.flowId = ''"
            >
          </v-select>
            <v-select
              v-if="formSelect.group_Flow_Id !== '' && formSelect.group_Flow_Id !== null"
              v-model="formSelect.flowId"
              :label="languageSelect === 0 ? 'แพ็คเกจ *' : 'Packages *'"
              :item-text="languageSelect === 0 ? 'text' : 'textEn'"
              dense
              outlined
              :items="DataFlow"
              attach
            :menu-props="{ bottom: true, offsetY: true }"
              @change="checkBranch(), checkTitleEmp()"
            >
            <template slot="item" slot-scope="data">
              <p class="text-wrap" >{{languageSelect === 0 ? data.item.text : data.item.textEn}}</p>
          </template>
        </v-select>
           <div class="mb-5" v-if="formSelect.masBranchID !== '' && formSelect.group_Flow_Id !== '' && formSelect.flowId !== ''">
            <v-item-group
              v-model="selectedEmpList"
              multiple
            >
              <v-row>
                <v-col
                  v-for="(emp,i) in dataEmpAll"
                  :key="i"
                  cols="6"
                  sm="6"
                  md="6"
                >
                  <v-item :value="emp.empId" v-slot="{ active, toggle }">
                    <v-sheet
                      elevation="6"
                      class="pa-2"
                    >
                    <v-img
                      v-if="emp.empImge"
                      max-height="150"
                      max-width="250"
                      :src="emp.empImge"
                      @click="openDialogPreView(emp.picture[0].gallery)"
                    ></v-img>
                    <div
                      v-else
                      style="max-width: 250px; max-height: 150px; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; border: 1px dashed #ccc;"
                    >
                      <v-icon
                        style="font-size: 96px;"
                      >
                      mdi-image-multiple
                      </v-icon>
                    </div>
                      <div class="mt-2 d-flex align-center justify-space-between" @click="toggle">
                        <div>
                          <div class="font-weight-bold">
                            {{ languageSelect === 0 ? emp.empFull_NameTH : emp.empFull_NameTH }}
                          </div>
                          <div class="text--secondary">
                          </div>
                        </div>
                        <v-icon color="primary">
                          {{ active ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                        </v-icon>
                      </div>
                    </v-sheet>
                  </v-item>
                </v-col>
              </v-row>
            </v-item-group>
           </div>
          </v-col>
        </v-row>
        <div v-if="formSelect.masBranchID !== '' && formSelect.group_Flow_Id !== '' && formSelect.flowId !== ''">
          <div class="pa-0" v-if="!overlayBulidQueue">
            <div class="pa-0 mb-2 mt-n10">
            <v-row>
              <v-col cols="2" class="text-center">
                <v-icon
                  class="mr-n13"
                  v-if="previous"
                  large
                  color="#000000"
                  @click="setMonthCarousel('previous')"
                >
                  mdi-skip-previous
                </v-icon>
              </v-col>
              <v-col cols="8" class="text-center">
              <v-menu
                ref="menupicker"
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="-80"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                    <h4
                    class="pa-1 text-center mt-0 font-weight-bold"
                    :style="'color:'+ '#000000' +';'"
                    v-bind="attrs"
                    v-on="on">
                    {{languageSelect === 0 ? defaultMonth.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date)) + 543) : defaultMonthEng.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date))) }}
                    </h4>
                </template>
                <v-date-picker
                  v-model="date"
                  type="month"
                  no-title
                  scrollable
                  @input="menu2 = false"
                  :min="currentMonth"
                  :locale="languageSelect === 0 ? 'th': 'sv-se'"
                  @change="setMonthCarousel()"
                ></v-date-picker>
              </v-menu>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-icon
                  class="ml-n13"
                  large
                  color="#000000"
                  @click="setMonthCarousel('next')"
                >
                  mdi-skip-next
                </v-icon>
              </v-col>
            </v-row>
          </div>
          <v-slide-group
            v-model="model"
            center-active
            class="pa-4 pt-0 mt-n1"
            color="primary"
          >
            <v-slide-item
              v-for="(item, n) in queueForMonth"
              :key="n"
            >
              <v-card
                v-if="!item.status_close"
                :color="item.active ? '#1F6FEB' : '#0D47A1'"
                :style="'border-radius: 15px 15px 15px 15px;'"
                class="ma-1 cardBox"
                height="65px"
                width="50px"
                v-on:click="item.active? item.active = false: item.active = true  ,getDetailsVela(item,n)"
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_th + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0 " v-else>
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_en + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0" >
                  <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day}}</h4>
                </v-col>
                </v-row>
              </v-card>
              <v-sheet
                v-else
                :color="item.active ? '#FFFFFF' : '#FFFFFF'"
                :style="'border-radius: 15px 15px 15px 15px;'"
                class="ma-1 cardBox"
                height="65px"
                width="50px"
                readonly
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_th + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0 " v-else>
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_en + '.'}}</p>
                </v-col>
                <v-col  cols="12" class="pa-0" >
                  <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold"  :style="'color:'+ '#000000'" >{{item.day}}</h4>
                </v-col>
                </v-row>
              </v-sheet>
            </v-slide-item>
          </v-slide-group>
          <v-expand-transition>
            <v-sheet
              v-if="queueForDateSelect.length > 0"
              min-height="200"
              tile
              class="pa-3 px-5 ml-2 mr-2"
            >
            <v-row>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'เวลา': 'Time'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div>
                      <v-sheet
                        class="font-weight-bold text-center"
                        color="#0D47A1"
                        width="100%"
                        height="36px"
                        elevation="2"
                        rounded
                        style="display: flex;justify-content: center;align-items: center;"
                        >
                      <p class="ma-0" style="word-wrap: break-word;color: #FFFFFF;font-size:small;">{{item}}</p>
                      </v-sheet>
                    </div>
                  </h5>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'จำนวนคิว': 'Queues'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div >
                      <v-btn
                        dark
                        class="font-weight-bold  text-center"
                        color="#0ACF83"
                        width="80%"
                        >{{languageSelect === 0 ? 'ว่าง': 'Ready'}}
                      </v-btn>
                    </div>
                  </h5>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'จองคิว': 'Booking'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div>
                      <v-btn
                        dark
                        class="font-weight-bold  text-center"
                        color="#0D47A1"
                        width="100%"
                        @click="selectTime(item)"
                        >
                        <v-icon left class="ml-1">
                          mdi-calendar-month
                        </v-icon>
                        {{languageSelect === 0 ? 'นัดหมาย': 'BOOKING'}}
                      </v-btn>
                    </div>
                  </h5>
                </div>
              </v-col>
            </v-row>
            </v-sheet>
          </v-expand-transition>
        </div>
        <div class="pa-0" v-else>
          <v-progress-linear
          indeterminate
          color="cyan"
          ></v-progress-linear>
        </div>
        </div>
      </v-sheet>
    </v-card>
     <v-dialog
      v-model="dialogSelectGoto"
      max-width="100%"
      persistent
    >
      <v-card style="background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);" height="auto">
        <v-container fluid class="pa-4">
          <!-- <div class="mb-2" style="text-align: end;">
            <v-card-title style="justify-content: space-between;"><div class="pl-3">กรุณาเลือก</div> <v-avatar color="#FAD4D4" size="35">
                  <span style="color:red;padding-bottom: 4px;"><v-icon class="iconify" color="red" data-icon="fluent:receipt-add-20-regular"></v-icon></span>
            </v-avatar></v-card-title>
          </div> -->
          <v-row dense>
            <v-col cols="6" style="border-right: 2px solid #ccd1e4;">
              <div style="text-align: center;" @click="dialogSelectGoto = false">
                <v-avatar color="#9A9897" size="50">
                  <span><span><v-icon class="iconify" color="white" style="font-size: 30px;" data-icon="fa:calendar"></v-icon></span></span>
                </v-avatar>
                <div>นัดหมายใหม่</div>
                <div>Boooking</div>
              </div>
            </v-col>
            <v-col cols="6" v-if="statusCheckDiposit">
              <div height="200px" style="text-align: center;" @click="gotoCheckUser('upload')">
                <v-avatar color="#9A9897" size="50">
                  <span><v-icon class="iconify" color="white" style="font-size: 40px;" data-icon="fluent:receipt-add-20-regular"></v-icon></span>
                </v-avatar>
                <div>แนบหลักฐานโอนเงิน</div>
                <div>Uploaded file</div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="dataEmpAll.filter(r => r.empId === formSelect.empId).length > 0"
      v-model="dialogGuruFulll"
      max-width="100%"
      persistent
    >
      <v-card style="background: linear-gradient(180deg, #ffffff 10%, #e1f3ff 100%);" height="auto">
        <v-container fluid class="pa-4">
          <v-row dense class="my-4">
            <v-col cols="12" class="text-center" style="border-right: 2px solid #ccd1e4;">
                <h5>เสียใจด้วย!</h5>
            </v-col>
            <v-col cols="12" class="text-center" style="border-right: 2px solid #ccd1e4;">
                <b>{{dataEmpAll.filter(r => r.empId === formSelect.empId)[0].empFirst_NameTH + ' ' + dataEmpAll.filter(r => r.empId === formSelect.empId)[0].empLast_NameTH}}</b> คิวเต็มแล้ว
            </v-col>
            <v-col cols="12" class="text-center" style="border-right: 2px solid #ccd1e4;">
                ลงชื่อสำรองได้ที่ลิงก์ด้านล่างนี้เลย
            </v-col>
            <v-col cols="12" class="text-center">
                <a href="https://forms.gle/o81yTppLgtGsNgGZ7" target="_blank"><b><u>คลิกที่นี่</u></b></a>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <DialogPreView
      v-model="showDialogPreView"
      :gallery="prodGallery"
    />
    <FormBooking
      v-model="showDialogCustomField"
      :fieldNameItem="fieldNameItem"
      :flowId="formSelect.flowId"
      :languageSelect="languageSelect"
      :selectedEmpDetailList="selectedEmpDetailList"
      :dueDateSelect="dueDateSelect"
      :dueTimeSelect="dueTimeSelect"
      :groupFlowId="formSelect.group_Flow_Id"
      :groupFlow="groupFlow"
      :DataFlow="DataFlow"
      @update-fieldNameItem="fieldNameItem = $event"
      @add-booking="addBooking()"
    />
    <GoogleCalendar ref="GoogleCalendarRef" />
  </v-main>
</template>

<script>
import axios from 'axios' // api
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import DialogPreView from './DialogPreView.vue'
import FormBooking from './FormBooking'
import GoogleCalendar from '../Core/GoogleCalendarCmp.vue'
export default {
  components: {
    name: '',
    QrcodeVue,
    DialogPreView,
    FormBooking,
    GoogleCalendar
  },
  watch: {
    async selectedEmpList (newVal, oldVal) {
      const isDifferent = JSON.stringify(newVal) !== JSON.stringify(oldVal)
      const hasValue = Array.isArray(newVal) && newVal.length > 0
      console.log('newVal', newVal, newVal.length)
      if (newVal.length === 0) {
        this.queueForMonth = []
        this.queueForDateSelect = []
      }
      if (isDifferent && hasValue) {
        const empListLimit = this.DataFlowNameAll.filter((item) => item.flowId === this.formSelect.flowId)[0].empList
        if (newVal.length <= empListLimit) {
          await this.getCalendarQueueVela()
        } else {
          this.selectedEmpList = [...oldVal]
          this.$swal(this.languageSelect === 0 ? `เพิ่มสูงสุดได้ไม่เกิน ${empListLimit} ฉาก` : `You can add up to a maximum of ${empListLimit} scene.`, ' ', 'info')
        }
      }
    }
  },
  computed: {
    selectedEmpDetailList () {
      return this.dataEmpAll.filter(emp =>
        this.selectedEmpList.includes(emp.empId)
      )
    }
  },
  data () {
    return {
      dialogGuruFulll: false,
      model: 0,
      previous: false,
      dateEng: [{text: 'อา', textEn: 'Sun'}, {text: 'จ', textEn: 'Mon'}, {text: 'อ', textEn: 'Tue'}, {text: 'พ', textEn: 'Wed'}, {text: 'พฤ', textEn: 'Thu'}, {text: 'ศ', textEn: 'Fri'}, {text: 'ส', textEn: 'Sat'}],
      defaultMonth: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      defaultMonthEng: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      menu2: false,
      date: moment(moment().format('YYYY-MM'), 'YYYY-MM').format('YYYY-MM'),
      currentMonth: moment().format('YYYY-MM'),
      allDetails: [],
      LimitBooking: [],
      dateSelect: [],
      formSelect: {
        group_Flow_Id: '',
        flowId: '',
        empId: '',
        masBranchID: '',
        datemonth: '',
        dateday: ''
      },
      value: '',
      size: 200,
      foreground: '#000000',
      valid: true,
      userName: '',
      userPassword: '',
      shopId: this.$route.query.shopId,
      profile: null,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      dialog: false,
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      bookingthankText: null,
      redirectBy: null,
      DataFlow: [],
      DataFlowNameAll: [],
      languageSelect: 0,
      dateDayCustom: [],
      dateDayoffValue: [],
      statusChek: false,
      dataEmp: [],
      dataEmpAll: [],
      EmpItemLimit: [],
      branchData: [],
      branch: [],
      timeavailable: [],
      empTitleTh: '',
      empTitleEng: '',
      timeSlotbyCustomer: [],
      customerTimeSlot: 'False',
      fromAddTimeCus: '',
      statusCheckDiposit: false,
      dialogSelectGoto: false,
      dataLineConfig: {},
      StatusChecknewCustome: false,
      newCustomerStatusOverlay: false,
      next_bookingNowCheckCount_month: 'False',
      imageSelectIndex: '',
      fromAdd: {
        bookingFieldId: null,
        bookingDataCustomerEmail: '',
        fieldId: '',
        fieldValue: '',
        flowId: '',
        masBranchID: '',
        empId: '',
        dueDate: '',
        shopId: '',
        userId: '',
        packageId: '',
        tokenPackage: '',
        statusUpload1: 'False',
        statusUpload2: 'False',
        fileUpload1: '',
        fileUpload2: ''
      },
      selected: {},
      bookingFormHeader: '',
      bookingFormHistoryBT: '',
      bookingFormConfirmBT: '',
      bookingFormHeaderEn: '',
      bookingFormHistoryBTEn: '',
      bookingFormConfirmBTEn: '',
      fieldNameItem: [],
      selectedEmpList: [],
      queueForMonth: [],
      queueForDateSelect: [],
      overlayBulidQueue: false,
      showDialogPreView: false,
      showDialogCustomField: false,
      prodGallery: [],
      dueDateSelect: '',
      dueTimeSelect: '',
      groupFlow: [],
      timeSlow: null,
      overlay: false,
      bookingFieldData: []
    }
  },
  async mounted () {
    let checkShopId = ''
    if (this.$route.query.shopId) {
      checkShopId = this.$route.query.shopId
    } else {
      const queryString = decodeURIComponent(window.location.search).replace(
        '?liff.state=',
        ''
      )
      console.log('queryString', queryString)
      const params = new URLSearchParams(queryString)
      checkShopId = params.get('shopId')
    }
    let dataLineConfig = await this.getDataLineConfig(checkShopId)
    this.dataLineConfig = dataLineConfig
    await this.checkLiffLogin(dataLineConfig)
    await this.checkBanUserId(this.profile.userId, checkShopId)
    await this.getShop()
    await this.getDataBranch()
    await this.getBookingField()
    await this.checkUserId()
    await this.getGroupFlow()
  },
  created () {
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.myEventHandler)
  },
  methods: {
    // แปลง fieldValue ของ Checkbox ให้เป็น array เสมอ
    // ข้อมูลเก่ามีทั้ง '' (ยังไม่เคยติ๊ก) และ JSON ที่เสียรูป ซึ่งทำให้ JSON.parse พัง
    parseCheckboxValue (value) {
      if (value === null || value === undefined || value === '') return []
      if (Array.isArray(value)) return value
      try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) return parsed
        if (parsed === null || parsed === '') return []
        return [parsed]
      } catch (e) {
        return []
      }
    },
    parseOptionField (optionField) {
      try {
        const parsed = JSON.parse(optionField)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    // ล้างค่าฟิลด์ให้ถูกชนิด
    // Checkbox ต้องเป็น '[]' ไม่ใช่ '' ไม่งั้นฝั่ง admin JSON.parse พัง
    // และต้องล้าง selected ด้วย ไม่งั้นหน้าจอยังโชว์ติ๊กอยู่ทั้งที่ค่าถูกล้างไปแล้ว
    resetFieldValue (fieldItem) {
      if (fieldItem.fieldType === 'Checkbox') {
        fieldItem.fieldValue = '[]'
        this.$set(this.selected, fieldItem.fieldId, [])
      } else {
        fieldItem.fieldValue = ''
      }
    },
    async openDialogPreView (gallery) {
      this.prodGallery = gallery || []
      if (this.prodGallery.length > 0) {
        this.showDialogPreView = true
      }
    },
    async openDialogCustomField () {
      this.showDialogCustomField = true
    },
    async getCalendarQueueVela () {
      const payload = {
        'dateMonth': this.date,
        'timeSlot': this.timeSlot,
        'empId': this.selectedEmpList
      }
      this.overlayBulidQueue = true
      try {
        const result = await axios.post(this.DNS_IP + '/employee_vela/get_calendar_queue', payload)
        if (result.data.status) {
          this.queueForMonth = result.data.message
          await this.defaultDetailsVela()
        } else {
          this.queueForMonth = []
        }
      } catch (error) {
        this.queueForMonth = []
      } finally {
        this.overlayBulidQueue = false
      }
    },
    async defaultDetailsVela () {
      for (let index = 0; index < this.queueForMonth.length; index++) {
        const element = this.queueForMonth[index]
        if (element.active) {
          this.getDetailsVela(element, index)
        }
      }
    },
    async getGroupFlow () {
      try {
        this.groupFlow = []
        let response = await axios.get(this.DNS_IP + '/Group_Flow/get?shopId=' + this.shopId)
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          if (parseInt(element.masBranchID) === parseInt(this.formSelect.masBranchID)) {
            let s = {}
            s.text = element.groupName
            s.textEn = element.groupNameEn
            s.value = element.group_Flow_Id
            this.groupFlow.push(s)
          }
          console.log('groupFlow', this.groupFlow)
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    showEmpInfo () {
      if (this.shopId === this.shopNameData.ECommerceExpo || this.shopId === this.shopNameData.Doctor) {
        return true
      } else {
        return false
      }
    },
    async selectBranch () {
      this.formSelect.group_Flow_Id = ''
      await this.getGroupFlow()
    },
    async selectGroupFlow () {
      this.selectedEmpList = []
      this.formSelect.flowId = ''
      this.dateSelect = []
      this.customerTimeSlot = 'False'
      await this.getDataFlow()
    },
    // flowOne () {
    //   if (this.DataFlowName.length === 1) {
    //     this.formSelect.flowId = this.DataFlowName[0].value
    //     this.checkBranch()
    //     this.checkTitleEmp()
    //   }
    // },
    async checkUserId () {
      this.statusCheckDiposit = false
      await axios
        .get(
          this.DNS_IP +
            '/booking_view/get?shopId=' +
            this.$route.query.shopId +
            '&userId=' +
            this.profile.userId +
            '&checkOnsite=is null&statusBt=null&checkDeposit=True&depositStatus=null'
        )
        .then(async response => {
          let rs = response.data
          console.log('response.data', rs)
          if (rs.status === false) {
            this.dialogSelectGoto = false
          } else {
            let checkDepositStatus = rs.filter(el => { return moment(el.dueDate).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD') })
            // console.log('response.data', checkDepositStatus)
            if (checkDepositStatus.length > 0) {
              this.statusCheckDiposit = true
              this.dialogSelectGoto = true
            } else {
              this.statusCheckDiposit = false
              this.dialogSelectGoto = false
            }
          }
        })
    },
    gotoCheckUser (text) {
      if (text === 'history') {
        this.$router.push('/CheckBookingNext?shopId=' + this.$route.query.shopId)
      } else {
        this.$router.push('/PaymentUpload?shopId=' + this.$route.query.shopId + '&languageSelect=' + this.languageSelect)
      }
    },
    calculateTime (start, end) {
      let countTime = null
      if (end > start) {
        let genTime = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
        let h = parseInt(genTime.split(':')[0])
        let m = parseInt(genTime.split(':')[1])
        if (h === 0 && m !== 0) {
          countTime = m + ' นาที'
        } else if (h !== 0 && m === 0) {
          countTime = h + ' ชม.'
        } else {
          countTime = h + ' ชม. ' + m + ' นาที'
        }
      } else {
        countTime = 'No Data'
      }
      return countTime
    },
    calculateTimeEng (start, end) {
      let countTime = null
      // if (end > start) {
      //   let time = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
      //   let h = parseInt(time.split(':')[0])
      //   let m = parseInt(time.split(':')[1])
      //   countTime = (h * 60) + m
      // } else {
      //   countTime = 0
      // }
      if (end > start) {
        let genTime = moment.utc(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).format('HH:mm')
        let h = parseInt(genTime.split(':')[0])
        let m = parseInt(genTime.split(':')[1])
        if (h === 0 && m !== 0) {
          countTime = m + ' min.'
        } else if (h !== 0 && m === 0) {
          countTime = h + ' h.'
        } else {
          countTime = h + ' h. ' + m + ' min.'
        }
      } else {
        countTime = 'No Data'
      }
      return countTime
    },
    checkTitleEmp () {
      let checkDataEmpTitle = this.DataFlowNameAll.filter(el => { return el.flowId === this.formSelect.flowId })
      if (checkDataEmpTitle.length > 0) {
        this.empTitleTh = checkDataEmpTitle[0].empTitleTh || 'พนักงานช่าง'
        this.empTitleEng = checkDataEmpTitle[0].empTitleEng || 'Employee'
      } else {
        this.empTitleTh = 'พนักงานช่าง'
        this.empTitleEng = 'Employee'
      }
    },
    async bookingBynewCustomerStatus () {
      // Link Local
      // window.location = 'http://localhost:8081/BookingFormEmp?shopId=' + this.shopId + '&source=CalendarBookingEmpnewCustomerStatus&flowId=' +
      // this.formSelect.flowId + '&empId=' + this.formSelect.empId + '&masBranchID=' + this.formSelect.masBranchID + '&languageSelect=' + this.languageSelect

      // link หลัก
      window.location = 'https://liff.line.me/' + this.dataLineConfig.liffBookingFormEmpID + '?shopId=' + this.shopId + '&source=CalendarBookingEmpnewCustomerStatus&flowId=' +
      this.formSelect.flowId + '&empId=' + this.formSelect.empId + '&masBranchID=' + this.formSelect.masBranchID + '&languageSelect=' + this.languageSelect
    },
    async checkBranch (defaultEmp = '') {
      let dataFlowFilter = this.DataFlowNameAll.filter((item) => item.flowId === this.formSelect.flowId)
      try {
        // let newCustomerStatus = dataFlowFilter[0].newCustomerStatus
        // console.log('new----->>>>', newCustomerStatus)
        // if (newCustomerStatus === 'True') {
        //   if (this.formSelect.masBranchID !== '') {
        //     this.newCustomerStatusOverlay = true
        //     this.formSelect.empId = defaultEmp
        //     await this.getEmp()
        //     // await this.bookingBynewCustomerStatus()
        //   }
        // } else {
        //   if (this.formSelect.masBranchID !== '') {
        //     this.timeSlot = dataFlowFilter[0].timeSlot
        //     this.formSelect.empId = defaultEmp
        //     await this.getEmp()
        //   }
        // }
        if (this.formSelect.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formSelect.empId = defaultEmp
          await this.getEmp()
        }
      } catch (err) {
        if (this.formSelect.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formSelect.empId = defaultEmp
          await this.getEmp()
        }
      }
    },
    async setMonthCarousel (item) {
      // console.log('//////////////////////////', moment(this.date, 'YYYY-MM').format('YYYY-MM'))
      // console.log('currentMonth', moment(this.currentMonth, 'YYYY-MM').format('YYYY-MM'))
      if (item === 'next') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'next_bookingNowCheckCount_month') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'previous') {
        this.date = moment(this.date).add(-1, 'months').format('YYYY-MM')
      } else {

      }
      if (moment(this.date, 'YYYY-MM').format('YYYY-MM') > moment(this.currentMonth, 'YYYY-MM').format('YYYY-MM')) {
        if (this.next_bookingNowCheckCount_month === 'False') {
          this.previous = true
        }
      } else {
        this.previous = false
      }
      await this.getCalendarQueueVela()
    },
    async selectTime (time) {
      this.dueTimeSelect = time
      await this.openDialogCustomField()
    },
    // async getDetailsVela (item, key) {
    //   this.queueForDateSelect = []
    //   this.dueDateSelect = ''
    //   this.queueForMonth.forEach((i, u) => {
    //     if (u !== key) {
    //       i.active = false
    //     } else {
    //       this.dueDateSelect = i.date
    //     }
    //   })
    //   let filterSelect = this.queueForMonth.filter((item) => item.active === true)
    //   if (filterSelect.length > 0) {
    //     this.queueForDateSelect = filterSelect[0].available_time
    //     console.log('this.queueForDateSelect', this.queueForDateSelect)
    //   } else {
    //     this.queueForDateSelect = []
    //   }
    //   this.model = key
    // },
    async getDetailsVela (item, key) {
      this.queueForDateSelect = []
      this.dueDateSelect = ''
      this.queueForMonth.forEach((i, u) => {
        if (u !== key) {
          i.active = false
        } else {
          this.dueDateSelect = i.date
          i.active = true
        }
      })

      let filterSelect = this.queueForMonth.filter((item) => item.active === true)
      if (filterSelect.length > 0) {
        // เวลาทั้งหมดของวันนั้น
        let times = filterSelect[0].available_time

        // เวลาไทย (Asia/Bangkok)
        const formatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Asia/Bangkok',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        })
        const now = new Date()
        const currentTime = formatter.format(now) // เช่น "14:32"

        // วันที่ไทย (yyyy-MM-dd)
        const todayThai = new Date(
          now.toLocaleString('en-US', { timeZone: 'Asia/Bangkok' })
        ).toISOString().slice(0, 10)

        // ถ้าเป็นวันเดียวกับวันนี้ → กรองเวลาที่เลยไปแล้วออก
        if (this.dueDateSelect === todayThai) {
          times = times.filter(t => t > currentTime)
        }

        this.queueForDateSelect = times
        console.log('this.queueForDateSelect', this.queueForDateSelect)
      } else {
        this.queueForDateSelect = []
      }
      this.model = key
    },
    async checkLiffLogin (dataLineConfig) {
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getBotinfo () {
      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
        const config = {
          headers: {
            'botId': this.$route.query.shopId
          }
        }
        await axios.get(url, config).then((response) => {
          let rs = response.data
          console.log('rs1', rs)
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    },
    getShop () {
      if (this.$route.query.shopId) {
        axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.$route.query.shopId).then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.shop = rs
            rs.forEach(v => {
              if (v.primaryColor) {
                this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                this.DarkModeBackground = v.primaryColor
                this.DarkModeButton = v.secondaryColor
              } else {
                this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                this.DarkModeBackground = '#FFFFFF'
                this.DarkModeButton = '#E1F3FF'
              }
              if (v.shopImge) {
                this.LoGo = v.shopImge
              } else {
                this.LoGo = require('@/assets/Thank.svg')
              }
              if (v.shopImageCover) {
                this.ImgCover = v.shopImageCover
              } else {
                if (v.category === 'ธุรกิจรถยนต์') {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                } else {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                }
              }
              if (v.darkMode === 'True') {
                this.DarkMode = '#FFFFFF'
                this.DarkModefont = '#000000'
                this.DarkModeStatus = true
              } else {
                this.DarkMode = '#ffffff00'
                this.DarkModefont = '#FFFFFF'
                this.DarkModeStatus = false
              }
            })
            this.bookingthankText = rs[0].bookingthankText
            console.log('this.bookingthankText', this.bookingthankText)
          } else {
            this.shop = null
          }
        })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = '#ffffff00'
        this.DarkModefont = '#173053'
      }
    },
    async getDataFlow () {
      this.DataFlowName = []
      this.DataFlowNameAll = []
      this.DataFlow = []
      let dataFlow = []
      let dataFlowName = []
      let dataFlowNameAll = []
      // console.log('DataFlowName', this.DataFlowName)
      await axios.get(this.DNS_IP + '/flow/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let checkBranchByFlow = d.masBranchID || 'All'
            if ((checkBranchByFlow === this.formSelect.masBranchID.toString()) || checkBranchByFlow === 'All') {
              if (d.group_Flow_Id === this.formSelect.group_Flow_Id) {
                if (this.StatusChecknewCustome === true) {
                  if (d.newCustomerStatus === 'True') {
                    d.text = d.flowName
                    d.textEn = d.flowNameEn
                    d.value = d.flowId
                    dataFlowName.push(d)
                    dataFlowNameAll.push(d)
                    dataFlow.push(d)
                  }
                } else {
                  d.text = d.flowName
                  d.textEn = d.flowNameEn
                  d.value = d.flowId
                  dataFlowName.push(d)
                  dataFlowNameAll.push(d)
                  dataFlow.push(d)
                }
              }
            }
          }
          this.DataFlowName = dataFlowName
          this.DataFlowNameAll = dataFlowNameAll
          this.DataFlow = dataFlow
        } else {
          this.DataFlow = []
          this.DataFlowName = []
          this.DataFlowNameAll = []
        }
      })
      console.log('this.DataFlow', this.DataFlow)
    },
    async getDataBranch () {
      this.branch = []
      this.branchData = []
      await axios.get(this.DNS_IP + '/master_branch/get?shopId=' + this.shopId).then(response => {
        let rs = response.data
        // console.log('rs', rs)
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let s = {}
            s.text = d.masBranchName
            s.textEn = d.masBranchNameEn
            s.value = d.masBranchID
            this.branch.push(s)
            this.branchData.push(d)
            // console.log('dtdtdtdt', this.branch)
          }
          if (this.branch.length === 1) {
            this.formSelect.masBranchID = this.branch[0].value
            this.CaseOneBranch()
            // this.checkTime()
            // this.getEmp()
          }
        }
      })
      // console.log('branchData', this.branchData)
    },
    async CaseOneBranch () {
      await this.selectBranch()
      // await this.flowOne()
    },
    async getEmp () {
      this.dataEmp = []
      this.dataEmpAll = []
      this.dateSelect = []
      this.timeSlotbyCustomer = []
      this.fromAddTimeCus = ''
      this.customerTimeSlot = 'False'
      await axios.get(this.DNS_IP + '/empSelect/get?privacyPage=bookingform&masBranchID=' + this.formSelect.masBranchID).then(response => {
        let rs = response.data
        console.log('rssssssssssssss', rs)
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.flowId !== null && d.flowId !== '') {
              let checkFlowId = JSON.parse(d.flowId)
              if (checkFlowId.filter((a) => parseInt(a) === this.formSelect.flowId).length > 0) {
                if (d.setTime !== null && d.setTime !== '[]' && d.setTime !== '') {
                  let s = {}
                  s.text = d.empFull_NameTH
                  s.textEng = d.empFull_NameTH
                  s.value = d.empId
                  s.creditpackage = d.credit_package
                  this.dataEmp.push(s)
                  // console.log(i, this.dataEmpAll.length, d)
                  // console.log(this.dataEmpAll)
                  d.picture = JSON.parse(d.pictureList) || []
                  this.dataEmpAll.push(d)
                  let limit = {}
                  limit.empId = d.empId
                  limit.limitBookingCheck = d.limitBookingCheck || 'False'
                  limit.setTime = d.setTime || '[]'
                  limit.setTimebyday = d.setTimebyday
                  this.EmpItemLimit.push(limit)
                }
              }
            }
          }
          if (this.dataEmp.length === 0) {
            this.$swal(
              this.languageSelect === 0 ? 'ไม่มี' + this.empTitleTh + 'สำหรับประเภทบริการนี้' : 'There is no ' + this.empTitleEng + ' for this type of service.',
              this.languageSelect === 0 ? 'กรุณาเลือกประเภทบริการอื่นๆ' : 'Please select another type of service.',
              'info'
            )
          }
        } else {
          this.dataEmp = []
          this.dataEmpAll = []
          this.EmpItemLimit = []
        }
      })
      console.log('dataEmp', this.dataEmpAll)
    },
    checkDateToTime (dateItem) {
      let dt = this.LimitBooking.filter((item) => moment(item.bookingDate).format('YYYY-MM-DD') === moment(dateItem, 'YYYY-MM-DD').format('YYYY-MM-DD'))
      if (dt.length > 0) {
        return dt
      } else {
        return 'False'
      }
    },
    async getBookingField () {
      let itemIncustomField = []
      await axios
        .get(this.DNS_IP + '/BookingField/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.fromAdd.bookingFieldId = rs[0].bookingFieldId
            this.bookingFieldData = rs
            let bookingData = []
            bookingData = JSON.parse(rs[0].flowfieldNameCustomer)
            for (let i = 0; i < bookingData.length; i++) {
              let d = bookingData[i]
              itemIncustomField.push(d.fieldId)
            }
            await this.getCustomField(itemIncustomField)
          } else {
            this.$swal(
              this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
              this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
              'info'
            )
              .then(result => {
                this.$router.go()
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.$router.go()
              })
          }
        })
        .catch(error => {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.$router.go()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.$router.go()
            })
          console.log('error function addData : ', error)
        })
    },
    async getCustomField (item) {
      await axios
        .get(this.DNS_IP + '/customField/fieldId?fieldId=' + item)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            let sortNo = rs.sort((a, b) => a.sortNoField - b.sortNoField)
            for (let i = 0; i < sortNo.length; i++) {
              let d = sortNo[i]
              let s = {}
              s.fieldId = d.fieldId
              s.fieldName = d.fieldName
              s.fieldNameEn = d.fieldNameEn
              s.fieldType = d.fieldType
              if (d.fieldType === 'Checkbox') {
                this.selected[s.fieldId] = []
              }
              s.optionField = d.optionField
              s.conditionField = d.conditionField
              s.conditionValue = d.conditionValue
              s.shopId = d.shopId
              s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
              s.requiredField = d.requiredField
              this.fieldNameItem.push(s)
            }
            var data1 = this.fieldNameItem.filter(
              el => parseInt(el.conditionField || 0) > 0
            )
            for (var i = 0; i < data1.length; i++) {
              var d = data1[i]
              var indexC = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === d.fieldId
              })
              var indexF = this.fieldNameItem.findIndex(function (o) {
                return o.fieldId === parseInt(d.conditionField)
              })
              this.fieldNameItem.splice(
                indexF + 1,
                0,
                this.fieldNameItem.splice(indexC, 1)[0]
              )
            }
            console.log('this.fieldNameItem', this.fieldNameItem)
            console.log('this.selected', this.selected)
          } else {
            this.$swal(
              this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
              this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
              'info'
            )
              .then(result => {
                this.$router.go()
              })
              .catch(error => {
                console.log('error function addData : ', error)
                this.$router.go()
              })
          }
        })
        .catch(error => {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.$router.go()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.$router.go()
            })
          console.log('error function addData : ', error)
        })
    },
    async addBooking () {
      let statusLimitFull = await this.checkLimitBooking()
      if (statusLimitFull) {
        await this.addBookingsubmit()
      }
    },
    async checkLimitBooking () {
      try {
        const payload = {
          'dateDay': this.dueDateSelect,
          'dateTime': this.dueTimeSelect,
          'timeSlot': this.timeSlot,
          'empId': this.selectedEmpList
        }
        const response = await axios.post(this.DNS_IP + '/employee_vela/check_limit_by_date', payload)
        console.log('response', response.data)
        if (response.data.status) {
          if (response.data.limit_full) {
            this.$swal(
              this.languageSelect === 0 ? 'มีลูกค้าท่านอื่นนัดหมายเวลานี้แล้ว' : 'There are other customers making appointments at this time.',
              this.languageSelect === 0 ? 'กรุณาเลือกวันที่ / เวลา ใหม่อีกครั้ง' : 'Please select a new date/time again.',
              'info'
            )
            return false
          } else {
            return true
          }
        } else {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
            'info'
          )
            .then(result => {
              this.$router.go()
            })
            .catch(error => {
              console.log('error function addData : ', error)
              this.$router.go()
            })
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async addBookingsubmit () {
      if (this.profile.userId !== null && this.profile.userId !== '') {
        let rs = this.fieldNameItem
        let Add = []
        let fielditem = this.fieldNameItem
        let dueDate = this.dueDateSelect + ' ' + this.dueTimeSelect
        let userId = ''
        if (this.$route.query.error === undefined) {
          userId = this.profile.userId
        } else {
          userId = 'system'
        }
        for (let i = 0; i < rs.length; i++) {
          let d = rs[i]
          let update = {}
          if (d.conditionField === '' || d.conditionField === null) {
            update.masBranchID = this.formSelect.masBranchID
            update.bookingFieldId = this.fromAdd.bookingFieldId
            update.flowId = this.formSelect.flowId
            update.empId = this.fromAdd.empId
            update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
            update.timeSlot = this.timeSlot
            update.fieldId = d.fieldId
            update.fieldName = d.fieldName
            update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
            update.shopId = d.shopId
            update.dueDate = dueDate
            update.timeText = this.dueTimeSelect
            update.sourceLink = 'CalendarBookingEmpVela'
            update.userId = userId
            update.CREATE_USER = userId || 'NotGetUserID'
            update.LAST_USER = userId || 'NotGetUserID'
            update.dateSelect = this.dueDateSelect
            update.timeSelect = this.dueTimeSelect
            update.bookingLanguage = this.languageSelect
            update.IsNotify = 'False'
            Add.push(update)
          } else {
            if (fielditem.filter(row => {
              return row.fieldId === parseInt(d.conditionField)
            }).length > 0
            ) {
              if (
                d.conditionValue ===
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              })[0].fieldValue
              ) {
                update.masBranchID = this.formSelect.masBranchID
                update.bookingFieldId = this.fromAdd.bookingFieldId
                update.flowId = this.formSelect.flowId
                update.empId = this.fromAdd.empId
                update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
                update.timeSlot = this.timeSlot
                update.fieldId = d.fieldId
                update.fieldName = d.fieldName
                update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
                update.shopId = d.shopId
                update.dueDate = dueDate
                update.timeText = this.dueTimeSelect
                update.sourceLink = 'CalendarBookingEmpVela'
                update.userId = userId
                update.CREATE_USER = userId || 'NotGetUserID'
                update.LAST_USER = userId || 'NotGetUserID'
                update.dateSelect = this.dueDateSelect
                update.timeSelect = this.dueTimeSelect
                update.bookingLanguage = this.languageSelect
                update.IsNotify = 'False'
                Add.push(update)
              }
            } else if (d.conditionField === 'flow') {
              if (parseInt(d.conditionValue) === parseInt(this.fromAdd.flowId)) {
                update.masBranchID = this.formSelect.masBranchID
                update.bookingFieldId = this.fromAdd.bookingFieldId
                update.flowId = this.formSelect.flowId
                update.empId = this.fromAdd.empId
                update.bookingEmpArray = JSON.stringify(this.selectedEmpList)
                update.timeSlot = this.timeSlot
                update.fieldId = d.fieldId
                update.fieldName = d.fieldName
                update.fieldValue = d.fieldValue.replace(/\\/g, '\\\\').replace(/%/g, '%%').replace(/'/g, "\\'")
                update.shopId = d.shopId
                update.dueDate = dueDate
                update.timeText = this.dueTimeSelect
                update.sourceLink = 'CalendarBookingEmpVela'
                update.userId = userId
                update.CREATE_USER = userId || 'NotGetUserID'
                update.LAST_USER = userId || 'NotGetUserID'
                update.dateSelect = this.dueDateSelect
                update.timeSelect = this.dueTimeSelect
                update.bookingLanguage = this.languageSelect
                update.IsNotify = 'False'
                Add.push(update)
              }
            }
          }
        }
        console.log('Add', Add)
        this.$swal({
          title: this.languageSelect === 0 ? 'ยืนยันรายการนัดหมาย' : 'Please confirm your booking',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
          cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
        })
          .then(async result => {
            this.overlay = true
            axios
              .post(this.DNS_IP + '/employee_vela/abb_booking', Add)
              .then(async response => {
                if (response.data.message === 'LimitBooking_Full') {
                  this.$swal(this.languageSelect === 0 ? 'คิวเต็มแล้ว' : 'Full queue', this.languageSelect === 0 ? 'กรุณาเลือกวันที่ใหม่อีกครั้ง' : 'Please select a new date again.', 'error')
                  this.overlay = false
                } else {
                  this.updateNewBookingFibase(this.shopId)
                  let bookNo = response.data.bookNo
                  let flowId = this.formSelect.flowId
                  let filterDataFlow = this.DataFlowNameAll.filter((item) => item.flowId === flowId)[0]
                  // console.log('response!!!!!!!!!!!', this.DataFlowNameAll.filter((item) => item.flowId === flowId))
                  let checkDeposit = filterDataFlow.checkDeposit
                  let amountDeposit = filterDataFlow.amountDeposit
                  let menuShowStatus = filterDataFlow.menuShowStatus
                  if ((checkDeposit === 'True' && amountDeposit > 0) || (checkDeposit === 'True' && menuShowStatus === 'True')) {
                    if (amountDeposit === 0 && this.priceMenu === 0) {
                      if (this.liffSendMessageAfterBookingStatus === 'True') {
                        let text = 'นัดหมายวันเวลาเรียบร้อย'
                        this.liffSendMessages(text)
                      }
                      await this.pushMsgLineNotifyGroup(bookNo)
                      if (filterDataFlow.updateStatusConfirm === 'True') {
                        await this.pushMsgConfirm(bookNo, flowId)
                      } else {
                        await this.pushMsgCustomer(bookNo, flowId)
                      }
                    } else {
                      if (this.liffSendMessageAfterBookingStatus === 'True') {
                        let text = 'รอจ่ายมัดจำอัพโหลดสลิป'
                        this.liffSendMessages(text)
                      }
                    }
                    if (filterDataFlow.updateStatusConfirm === 'True' && checkDeposit !== 'True') {
                      let dtt = {
                        bookNo: bookNo,
                        contactDate: moment().format('YYYY-MM-DD HH:mm'),
                        status: 'confirm',
                        statusUse: 'use',
                        shopId: this.shopId,
                        CREATE_USER: userId,
                        LAST_USER: userId
                      }
                      await axios
                        .post(this.DNS_IP + '/booking_transaction/add', dtt)
                        .then(async response => {
                          if (this.statusGoogleCalendar === 'True') {
                            this.connectGoogleCalendar(dtt.shopId, 'Add', dtt.bookNo)
                          }
                        }).catch(error => {
                          console.log('error function booking_transaction : ', error)
                        })
                    }
                    let Calculate = 1
                    if (this.languageSelect === 0) {
                      this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=BookingForm&flowId=' + flowId + '&bookNo=' + bookNo + '&languageSelect=' + this.languageSelect + '&Calculate=' + Calculate)
                    } else {
                      let statusEngPayment = this.bookingFieldData[0].statusEngPayment || 'False'
                      if (statusEngPayment === 'False') {
                        await this.pushMsgLineNotifyGroup(bookNo)
                        if (filterDataFlow.updateStatusConfirm === 'True') {
                          await this.pushMsgConfirm(bookNo, flowId)
                        } else {
                          await this.pushMsgCustomer(bookNo, flowId)
                        }
                      } else {
                        this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=BookingForm&flowId=' + flowId + '&bookNo=' + bookNo + '&languageSelect=' + this.languageSelect + '&Calculate=' + Calculate)
                      }
                    }
                    // await this.getCondition(flowId, 'Thank', bookNo)
                  } else {
                    if (this.liffSendMessageAfterBookingStatus === 'True') {
                      let text = 'นัดหมายวันเวลาเรียบร้อย'
                      this.liffSendMessages(text)
                    }
                    if (filterDataFlow.updateStatusConfirm === 'True') {
                      let dtt = {
                        bookNo: bookNo,
                        contactDate: moment().format('YYYY-MM-DD HH:mm'),
                        status: 'confirm',
                        statusUse: 'use',
                        shopId: this.shopId,
                        CREATE_USER: userId,
                        LAST_USER: userId
                      }
                      await axios
                        .post(this.DNS_IP + '/booking_transaction/add', dtt)
                        .then(async response => {
                          if (this.statusGoogleCalendar === 'True') {
                            this.connectGoogleCalendar(dtt.shopId, 'Add', dtt.bookNo)
                          }
                        }).catch(error => {
                          console.log('error function booking_transaction : ', error)
                        })
                    }
                    await this.pushMsgLineNotifyGroup(bookNo)
                    if (filterDataFlow.updateStatusConfirm === 'True') {
                      await this.pushMsgConfirm(bookNo, flowId)
                    } else {
                      await this.pushMsgCustomer(bookNo, flowId)
                    }
                  }
                }
              })
              .catch(error => {
                this.overlay = false
                console.log('error function addData : ', error)
              })
          })
          .catch(error => {
            this.overlay = false
            console.log('Cencel : ', error)
          })
      } else {
        this.$swal(
          this.languageSelect === 0 ? 'ไม่พบข้อมูล LineUserID ' : 'LineUserID data not found.',
          this.languageSelect === 0 ? 'กรุณากดปุ่มเพิ่อดึงข้อมูลใหม่' : 'Please press the button to fetch new data.',
          'info'
        )
          .then(result => {
            this.$router.go()
          })
          .catch(error => {
            console.log('error function addData : ', error)
            this.$router.go()
          })
      }
    },
    async connectGoogleCalendar (shopId, status, bookNo) {
      const payload = {
        bookNo: bookNo,
        status: status
      }
      await axios
        .post(this.DNS_IP + '/GoogleCalendarApi/event/byBookNo', payload)
        .then(response => {
          console.log('response connectGoogleCalendar : ', response)
        })
        .catch((error) => {
          console.log('error connectGoogleCalendar : ', error)
        })
      // this.$refs.GoogleCalendarRef.checkTypeEvenEmp(shopId, status, bookNo)
    },
    async liffSendMessages (textitem) {
      try {
        await this.$liff.sendMessages([
          {
            type: 'text',
            text: textitem
          }
        ])
      } catch (error) {
        // alert(error)
        console.log('error', error)
      }
    },
    async pushMsgCustomer (bookNo, flowId) {
      const result = await axios.get(
        this.DNS_IP +
          '/member/get?shopId=' +
          this.shopId +
          '&liffUserId=' +
          this.profile.userId
      )
      if (result.data.status === false) {
        let statusSend = {
          statusSend: 'false'
        }
        await axios.post(this.DNS_IP + '/Booking/edit/' + bookNo, statusSend)
        console.log('statusSend', 'false')
        if (this.$liff.isInClient()) {
          // if (this.profile.userId === 'U29e920c9ca4411b09b8c1704f37197c3' || this.profile.userId === 'U35b246f2825895f3fdcc09b72d589f92') {
          //   alert('isInClient')
          // }
          this.$liff
            .sendMessages([
              {
                type: 'text',
                text: 'เปิดรับการแจ้งเตือน'
              }
            ])
            .then(() => {
              console.log('message sent')
              // alert('message sent')
              // this.$liff.closeWindow()
            })
            .catch((err) => {
              console.log('error', err)
              // alert('error:' + err)
            })
        }
        await this.getCondition(flowId, 'Thank', bookNo)
      } else {
        let statusSend = {
          statusSend: 'true'
        }
        await axios.post(this.DNS_IP + '/Booking/edit/' + bookNo, statusSend)
        // let lineUserId = result.data[0].lineUserId
        console.log('statusSend', 'true')
        let updateStatusSend = {
          updateStatusSend: 'false'
        }
        axios
          .post(
            this.DNS_IP + '/Booking/pushMsgCustomer/' + bookNo,
            updateStatusSend
          )
          .then(async response => {
            await this.getCondition(flowId, 'Thank', bookNo)
          })
      }
      // this.clearData()
    },
    async pushMsgConfirm (bookNo, flowId) {
      await axios
        .post(this.DNS_IP + '/Booking/pushMsgConfirm/' + bookNo)
        .then(async response => {
          await this.getCondition(flowId, 'Thank', bookNo)
        }).catch(error => {
          console.log('error function pushMsgQueue : ', error)
        })
    },
    async pushMsgLineNotifyGroup (bookNo) {
      await axios
        .post(this.DNS_IP + '/Booking/pushMsgLineNotifyGroupBefamily/' + bookNo)
        .then(response => {
        })
    },
    async getCondition (flowId, text, bookNo) {
      console.log('test', text)
      await axios
        .get(
          this.DNS_IP + '/flow/get?flowId=' + flowId + '&shopId=' + this.shopId
        )
        .then(response => {
          let rs = response.data
          if (rs.status === false) {
            if (text === 'BookingQrcode') {
              this.$router.push(
                '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId + '&languageSelect=' + this.languageSelect
              )
            } else {
              this.$router.push(
                '/Thank?shopId=' + this.shopId + '&redirectBy=BookingForm&flowId=' + flowId + '&bookNo=' + bookNo + '&languageSelect=' + this.languageSelect)
            }
          } else {
            if (rs[0].showCondition === 'แสดง') {
              this.$router.push(
                '/ConditionFlow?shopId=' + this.shopId + '&flowId=' + flowId + '&languageSelect=' + this.languageSelect
              )
            } else {
              if (text === 'BookingQrcode') {
                this.$router.push(
                  '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId + '&languageSelect=' + this.languageSelect
                )
              } else {
                this.$router.push(
                  '/Thank?shopId=' + this.shopId + '&redirectBy=BookingForm&flowId=' + flowId + '&bookNo=' + bookNo + '&languageSelect=' + this.languageSelect)
              }
            }
          }
        })
    }
  }
}
</script>

<style scoped>
.cardradius {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  -webkit-box-shadow: 0 3px 1px -2px rgb(255, 255, 255), 0 2px 2px 0 rgb(255 255 255), 0 1px 5px 0 rgb(255 255 255) !important;
    box-shadow: 0 3px 1px -2px rgb(255, 255, 255), 0 2px 2px 0 rgb(255 255 255), 0 1px 5px 0 rgb(255 255 255) !important;
}
.cardBox {
  box-shadow: 0 3px 1px -2px rgb(255, 255, 255), 0 2px 2px 0 rgb(255 255 255), 0 1px 5px 0 rgb(255 255 255);
}
.button {
  width: 45%;
  color: #fff;
  font-weight: 150;
  letter-spacing: 1px;
  margin: 6px 3px;
  padding: 10px 28px;
  border-radius: 25px !important;
  background-color: #0047a5;
}
.main{
  background-color: #FFFFFF;
  height: 100vh;
}
.content{
  overflow:auto;
  white-space: normal;
}
.a{
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Vela/CalendarBookingEmpVela.vue